module.exports = __webpack_public_path__ + "static/media/fall-min.da9acdc1.jpeg";